// extracted by mini-css-extract-plugin
export var button = "button-module--button--dc634";
export var disabled = "button-module--disabled--83e77";
export var hasPrimaryProp = "button-module--hasPrimaryProp--109fd";
export var icon = "button-module--icon--c5ab8";
export var iconButton = "button-module--iconButton--c04b4";
export var iconHover = "button-module--iconHover--3a15a";
export var iconWrapper = "button-module--iconWrapper--de177";
export var justText = "button-module--justText--afff8";
export var ldsRing = "button-module--ldsRing--d85da";
export var outline = "button-module--outline--4a727";
export var primary = "button-module--primary--b6f6d";
export var secondary = "button-module--secondary--02485";
export var tertiary = "button-module--tertiary--50b30";
export var whiteText = "button-module--whiteText--16474";